import Image from 'next/image';
import useLocale from 'next-translate/useTranslation';
import React from 'react';

const TestimonialsSpecial = () => {
  const { t } = useLocale('testimonials');

  return (
    <div className='mb-8 grid xl:mb-12 xl:grid-cols-2 space-y-12 xl:space-y-0 m-8 xl:m-12 '>
      <figure className='relative rounded-2xl bg-white dark:bg-slate-700 p-6 shadow-xl xl:mr-6 shadow-slate-900/10'>
        <blockquote className='relative text-left'>
          <div className='flex'>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
          </div>
          <p className="mt-4 dark:text-slate-200 text-left text-lg font-semibold leading-6 before:content-['“'] after:content-['”']">
            {t("It's a game changer.")}
          </p>
          <p className='text-lg tracking-tight text-slate-900 mt-3 dark:text-slate-400'>
            {t(
              'All content writers, marketing execs, & businesses with lean marketing teams! Easy-Peasy.AI helps frame great content, images for Social Media, Ads, Blogs, SEO.'
            )}
          </p>
        </blockquote>
        <figcaption className='relative mt-6 flex items-center justify-between border-t border-slate-100 dark:border-slate-100/10 pt-6'>
          <div>
            <div className='font-display text-left text-base text-slate-900 dark:text-slate-300'>
              Ankita Mehta
            </div>
            <div className='mt-1 text-sm text-slate-500'>
              {t('Chief Operating Officer at OYO')}
            </div>
          </div>
          <div className='overflow-hidden rounded-full bg-slate-50'>
            <Image
              alt=''
              width='56'
              height='56'
              className='h-14 w-14 object-cover'
              src='/images/ankita.png'
            />
          </div>
        </figcaption>
      </figure>

      <figure className='relative rounded-2xl bg-white dark:bg-slate-700 p-6 shadow-xl xl:ml-6 shadow-slate-900/10'>
        <blockquote className='relative text-left'>
          <div className='flex'>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
            <svg
              viewBox='0 0 20 20'
              aria-hidden='true'
              className='h-5 w-5 fill-primary-500'
            >
              <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
            </svg>
          </div>
          <p className="mt-4 text-lg dark:text-slate-200 text-left font-semibold leading-6 before:content-['“'] after:content-['”']">
            {t("It's like a superpower.")}
          </p>
          <p className='text-lg tracking-tight text-slate-900 mt-3 dark:text-slate-400'>
            {t(
              'I am BLOWN AWAY at the show notes generator. I just generated something that I am going to send directly a client. Only need to correct the names. Incredible.'
            )}
          </p>
        </blockquote>
        <figcaption className='relative mt-6 flex items-center justify-between border-t border-slate-100 dark:border-slate-100/10 pt-6'>
          <div>
            <div className='font-display text-left text-base text-slate-900 dark:text-slate-300'>
              Cody Crabb
            </div>
            <div className='mt-1 text-sm text-slate-500'>
              {t('Podcast Manager')}
            </div>
          </div>
          <div className='overflow-hidden rounded-full bg-slate-50'>
            <Image
              alt=''
              width='56'
              height='56'
              className='h-14 w-14 object-cover'
              src='/images/cody.jpeg'
            />
          </div>
        </figcaption>
      </figure>
    </div>
  );
};

export default TestimonialsSpecial;
